import { DigitalRevisionMenuItem } from '../interfaces/digital-revision-menu-item';
import { MenuItemTypeEnum } from '../interfaces/menu-item-type-enum';
import { AudioVideoSubcategoryTypeEnum } from '../interfaces/audio-video.model';

export const HomePageMenuItems: DigitalRevisionMenuItem[] = [
  {
    MenuItemType: MenuItemTypeEnum.Writing,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to videos',
    ButtonURL: '',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Writing',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      "<p>These videos show you how you could answer some of your writing questions — we\'ve used our best handwriting especially!</p>",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Example answer videos',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Title: 'Writing Video Solutions',
        Intro:
          'Use these videos to help you find out how to approach some of the writing questions in your book.',
        LeftSections: [
          {
            Header: 'Section One — General Stuff',
            Subcategories: [
              {
                Name: 'Questions and Being Polite — Q4',
                ShortName: 'Questions-and-Being-Polite-Q4',
                Link: 'https://www.youtube.com/embed/Vz5TUJIlwJU?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Two — Identity and Relationships with Others',
            Subcategories: [
              {
                Name: 'Describing People and Relationships — Q3 (Foundation)',
                ShortName: 'Describing-People-and-Relationships-Q3-Foundation',
                Link: 'https://www.youtube.com/embed/ZoB1kH8ywWM?rel=0&modestbranding=1',
              },
              {
                Name: 'Describing People and Relationships — Q3 (Higher)',
                ShortName: 'Describing-People-and-Relationships-Q3-Higher',
                Link: 'https://www.youtube.com/embed/aHn-CRiEb6o?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Six — Free-time Activities',
            Subcategories: [
              {
                Name: 'Cinema, TV and Music — Q3',
                ShortName: 'Cinema-TV-and-Music-Q3',
                Link: 'https://www.youtube.com/embed/ackUKi2TmUg?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Theme 2 — Mixed Practice',
            Subcategories: [
              {
                Name: 'Theme 2 Mixed Practice Foundation — Q5',
                ShortName: 'Theme-2-Mixed-Practice-Foundation-Q5',
                Link: 'https://www.youtube.com/embed/lblEGXjNtu4?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Twelve — The Environment and Social Issues',
            Subcategories: [
              {
                Name: 'Social Issues — Q2',
                ShortName: 'Social-Issues-Q2',
                Link: 'https://www.youtube.com/embed/iIHdlagzMKM?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [],
      },
    ],
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Writing',
        ImagePath: '/assets/images/landing/writing.png',
        DestinationPage: 'Writing',
      },
      {
        Text: 'Reading',
        ImagePath: '/assets/images/landing/reading.png',
        DestinationPage: 'Reading',
      },
      {
        Text: 'Listening',
        ImagePath: '/assets/images/landing/practice-audio.png',
        DestinationPage: 'Listening',
      },
      {
        Text: 'Speaking',
        ImagePath: '/assets/images/landing/q-a-audio.png',
        DestinationPage: 'Speaking',
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.Reading,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to videos',
    ButtonURL: '',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Reading',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Watch us work through some of the reading questions in your book.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Example answer videos',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Title: 'Reading Video Solutions',
        Intro:
          'Our experts work through some of the reading questions in your book — take your pick!',
        LeftSections: [
          {
            Header: 'Section One — General Stuff',
            Subcategories: [
              {
                Name: 'Numbers, Times and Dates — Q2',
                ShortName: 'Numbers-Times-and-Dates-Q2',
                Link: 'https://www.youtube.com/embed/0GJugL8hHZA?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Two — Identity and Relationships with Others',
            Subcategories: [
              {
                Name: 'About Yourself and My Family & Friends — Q2',
                ShortName: 'About-Yourself-and-My-Family-and-Friends-Q2',
                Link: 'https://www.youtube.com/embed/zABmpNxVMs0?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Three — Healthy Living and Lifestyle',
            Subcategories: [
              {
                Name: 'Illnesses and Treatments  — Q3',
                ShortName: 'Illnesses-and-Treatments-Q3',
                Link: 'https://www.youtube.com/embed/N_uKiUCyIiw?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Seven — Customs, Festivals and Celebrations',
            Subcategories: [
              {
                Name: 'Customs, Festivals and Celebrations — Q4',
                ShortName: 'Customs-Festivals-and-Celebrations-Q4',
                Link: 'https://www.youtube.com/embed/fuxjIX0JDII?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Eleven — Where People Live',
            Subcategories: [
              {
                Name: 'At Home — Q3',
                ShortName: 'At-Home-Q3',
                Link: 'https://www.youtube.com/embed/g2hCJWW_jmw?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Theme 3 — Mixed Practice',
            Subcategories: [
              {
                Name: 'Theme 3 Mixed Practice Foundation — Q5',
                ShortName: 'Theme-3-Mixed-Practice-Foundation-Q5',
                Link: 'https://www.youtube.com/embed/WYjAsLxOlNU?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [],
      },
    ],
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Writing',
        ImagePath: '/assets/images/landing/writing.png',
        DestinationPage: 'Writing',
      },
      {
        Text: 'Reading',
        ImagePath: '/assets/images/landing/reading.png',
        DestinationPage: 'Reading',
      },
      {
        Text: 'Listening',
        ImagePath: '/assets/images/landing/practice-audio.png',
        DestinationPage: 'Listening',
      },
      {
        Text: 'Speaking',
        ImagePath: '/assets/images/landing/q-a-audio.png',
        DestinationPage: 'Speaking',
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      TrackFilePaths: [],
      AdditionalInfo: '',
    },
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.ListeningTracks,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to audio',
    ButtonURL: '',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Listening',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      "<p>You\'ve hit the listening jackpot — here\'s all the audio you\'ll need for your listening questions.</p>",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Audio for all listening questions',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Writing',
        ImagePath: '/assets/images/landing/writing.png',
        DestinationPage: 'Writing',
      },
      {
        Text: 'Reading',
        ImagePath: '/assets/images/landing/reading.png',
        DestinationPage: 'Reading',
      },
      {
        Text: 'Listening',
        ImagePath: '/assets/images/landing/practice-audio.png',
        DestinationPage: 'Listening',
      },
      {
        Text: 'Speaking',
        ImagePath: '/assets/images/landing/q-a-audio.png',
        DestinationPage: 'Speaking',
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Audio',
      Intro: 'Choose a listening question in your book and find the matching audio track below!',
      ProductTitle: 'GCSE AQA Spanish Exam Practice Workbook',
      TrackFilePaths: [
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/01-listening-track-01-numbers-times-and-dates.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/02-listening-track-02-questions-and-being-polite.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/03-listening-track-03-opinions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/04-listening-track-04-opinions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/05-listening-track-05-about-yourself-and-my-family-friends.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/06-listening-track-06-describing-people-and-relationships.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/07-listening-track-07-describing-people-and-relationships.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/08-listening-track-08-food-and-healthy-unhealthy-living.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/09-listening-track-09-illnesses-and-treatments.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/10-listening-track-10-school-subjects-and-school-life.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/11-listening-track-11-school-pressures-and-difficulties.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/12-listening-track-12-school-pressures-and-difficulties.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/13-listening-track-13-education-post-16-and-career-choices.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/14-listening-track-14-mixed-practice-foundation.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/15-listening-track-15-mixed-practice-both-tiers.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/16-listening-track-16-mixed-practice-both-tiers.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/17-listening-track-17-mixed-practice-higher.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/18-listening-track-18-mixed-practice-higher.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/19-listening-track-19-cinema-tv-and-music.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/20-listening-track-20-sport-going-out-and-other-hobbies.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/21-listening-track-21-customs-festivals-and-celebrations.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/22-listening-track-22-customs-festivals-and-celebrations.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/23-listening-track-23-favourite-celebrities-and-celebrity-culture.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/24-listening-track-24-favourite-celebrities-and-celebrity-culture.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/25-listening-track-25-mixed-practice-foundation.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/26-listening-track-26-mixed-practice-both-tiers.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/27-listening-track-27-mixed-practice-both-tiers.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/28-listening-track-28-mixed-practice-both-tiers.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/29-listening-track-29-mixed-practice-higher.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/30-listening-track-30-mixed-practice-higher.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/31-listening-track-31-where-to-go-accommodation-and-travel.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/32-listening-track-32-getting-around-and-what-to-do.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/33-listening-track-33-technology-and-the-internet.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/34-listening-track-34-technology-and-the-internet.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/35-listening-track-35-social-media.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/36-listening-track-36-at-home.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/37-listening-track-37-the-environment.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/38-listening-track-38-social-issues.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/39-listening-track-39-social-issues.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/40-listening-track-40-mixed-practice-foundation.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/41-listening-track-41-mixed-practice-both-tiers.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/42-listening-track-42-mixed-practice-both-tiers.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/43-listening-track-43-mixed-practice-both-tiers.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/listening/44-listening-track-44-mixed-practice-higher.mp3',
      ],
      AdditionalInfo: '',
    },
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.Speaking,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to audio and videos',
    ButtonURL: '',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Speaking',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      "<p>All the audio for your speaking questions and some example answers from our speaking pros — let\'s go!</p>\n",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Audio and example answer videos',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Writing',
        ImagePath: '/assets/images/landing/writing.png',
        DestinationPage: 'Writing',
      },
      {
        Text: 'Reading',
        ImagePath: '/assets/images/landing/reading.png',
        DestinationPage: 'Reading',
      },
      {
        Text: 'Listening',
        ImagePath: '/assets/images/landing/practice-audio.png',
        DestinationPage: 'Listening',
      },
      {
        Text: 'Speaking',
        ImagePath: '/assets/images/landing/q-a-audio.png',
        DestinationPage: 'Speaking',
      },
    ],
    AudioVideo: {
      Intro:
        'Check out the audio for the speaking questions in your book or take a look at our handy videos, which give you some example answers.',
      Title: 'Speaking Audio and Video Solutions',
      LeftSections: [
        {
          Title: 'Speaking Audio',
          Header: '',
          Subcategories: [
            {
              Name: 'Speaking Audio',
              Link: '',
              LinkName: '',
              Description:
                'Choose a speaking question in your book and find the matching audio track below!',
              Type: AudioVideoSubcategoryTypeEnum.Audio,
              TrackFilePaths: [
                '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/speaking/01-speaking-track-01-about-yourself-and-my-family-friends.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/speaking/02-speaking-track-02-describing-people-and-relationships.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/speaking/03-speaking-track-03-food-and-healthy-unhealthy-living.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/speaking/04-speaking-track-04-illnesses-and-treatments.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/speaking/05-speaking-track-05-school-subjects-and-school-life.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/speaking/06-speaking-track-06-education-post-16-and-career-choices.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/speaking/07-speaking-track-07-mixed-practice-foundation.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/speaking/08-speaking-track-08-mixed-practice-higher.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/speaking/09-speaking-track-09-sport-going-out-and-other-hobbies.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/speaking/10-speaking-track-10-customs-festivals-and-celebrations.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/speaking/11-speaking-track-11-favourite-celebrities-and-celebrity-culture.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/speaking/12-speaking-track-12-mixed-practice-foundation.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/speaking/13-speaking-track-13-mixed-practice-higher.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/speaking/14-speaking-track-14-getting-around-and-what-to-do.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/speaking/15-speaking-track-15-technology-and-the-internet.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/speaking/16-speaking-track-16-social-media.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/speaking/17-speaking-track-17-the-local-area-directions-and-weather.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/speaking/18-speaking-track-18-the-environment.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/speaking/19-speaking-track-19-mixed-practice-foundation.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/SPAQ42/Audio/speaking/20-speaking-track-20-mixed-practice-higher.mp3',
              ],
            },
          ],
        },
        {
          Title: 'Speaking Video Solutions',
          Header: 'Section Four — Education',
          Subcategories: [
            {
              Name: 'School Subjects and School Life — Q1',
              Link: 'https://www.youtube.com/embed/-Mgzqs5j3Z8?rel=0&modestbranding=1',
              LinkName: 'School-Subjects-and-School-Life-Q1',
              Description: '',
              Type: AudioVideoSubcategoryTypeEnum.Video,
              TrackFilePaths: [],
            },
          ],
        },
        {
          Title: '',
          Header: 'Theme 1 — Mixed Practice',
          Subcategories: [
            {
              Name: 'Theme 1 Mixed Practice Higher — Q3',
              Link: 'https://www.youtube.com/embed/SeABn6-N-cQ?rel=0&modestbranding=1',
              LinkName: 'Theme-1-Mixed-Practice-Higher-Q3',
              Description: '',
              Type: AudioVideoSubcategoryTypeEnum.Video,
              TrackFilePaths: [],
            },
          ],
        },
        {
          Title: '',
          Header: 'Section Six — Free-time Activities',
          Subcategories: [
            {
              Name: 'Sport, Going Out and Other Hobbies — Q3',
              Link: 'https://www.youtube.com/embed/ui6-Emf5VJ4?rel=0&modestbranding=1',
              LinkName: 'Sport-Going-Out-and-Other-Hobbies-Q3',
              Description: '',
              Type: AudioVideoSubcategoryTypeEnum.Video,
              TrackFilePaths: [],
            },
          ],
        },
        {
          Title: '',
          Header: 'Theme 2 — Mixed Practice',
          Subcategories: [
            {
              Name: 'Theme 2 Mixed Practice Higher — Q5',
              Link: 'https://www.youtube.com/embed/dZSOwrEsJWk?rel=0&modestbranding=1',
              LinkName: 'Theme-2-Mixed-Practice-Higher-Q5',
              Description: '',
              Type: AudioVideoSubcategoryTypeEnum.Video,
              TrackFilePaths: [],
            },
          ],
        },
        {
          Title: '',
          Header: 'Section Nine — Travel and Tourism',
          Subcategories: [
            {
              Name: 'Getting Around and What to Do — Q1',
              Link: 'https://www.youtube.com/embed/ruI0V25I-rA?rel=0&modestbranding=1',
              LinkName: 'Getting-Around-and-What-to-Do-Q1',
              Description: '',
              Type: AudioVideoSubcategoryTypeEnum.Video,
              TrackFilePaths: [],
            },
          ],
        },
        {
          Title: '',
          Header: 'Section Twelve — The Environment and Social Issues',
          Subcategories: [
            {
              Name: 'The Environment — Q4',
              Link: 'https://www.youtube.com/embed/c9Wl-1G3rks?rel=0&modestbranding=1',
              LinkName: 'The-Environment-Q4',
              Description: '',
              Type: AudioVideoSubcategoryTypeEnum.Video,
              TrackFilePaths: [],
            },
          ],
        },
      ],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      Intro: '',
      IntroTitle: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.OnlineEdition,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Your Online Library',
    ButtonURL: '[[external_domain]]/bookspacedemo',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Online Edition',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Use your book wherever you are with your Online Edition — yippee!</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Read your eBook here',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.Extras,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'View Extras',
    MixedOnlineTests: [],

    ButtonURL: 'extras',
    HasData: false,
    HeadingText: 'Extra Useful Bits',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      "<p>Printable answers, transcripts, and vocabulary lists — yep, it's all right here.</p>",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Other resources to download',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    HowToUseThisBook: {
      Text: "We've put together lots of helpful information on how to get the most out of your Revision Guide. And if you've hit any snags, you'll find the answers you need here too.",
      VideoLink: 'https://www.youtube.com/embed/-TqrRoP-g9I?rel=0&modestbranding=1',
    },
    ExtrasOrAnswers: {
      HeaderText: 'Extra Useful Bits',
      ContentMain:
        '<h3>Speaking</h3>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SPAQ42/PDFs/cgp-gcse-spanish-speaking-transcripts.pdf" style="color: rgb(20, 148, 212);" target="_blank">Speaking Transcripts</a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SPAQ42/PDFs/cgp-gcse-spanish-speaking-mark-schemes.pdf" style="color: rgb(20, 148, 212);" target="_blank">Speaking Mark Schemes</a></p>\n' +
        '\n' +
        '<h3>Listening</h3>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SPAQ42/PDFs/cgp-gcse-spanish-listening-transcripts.pdf" style="color: rgb(20, 148, 212);" target="_blank">Listening Transcripts</a></p>\n' +
        '\n' +
        '<h3>Writing</h3>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SPAQ42/PDFs/cgp-gcse-spanish-writing-mark-schemes.pdf" style="color: rgb(20, 148, 212);" target="_blank">Writing Mark Schemes</a></p>\n' +
        '\n' +
        '<p>&nbsp;</p>\n',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Writing',
        ImagePath: '/assets/images/landing/writing.png',
        DestinationPage: 'Writing',
      },
      {
        Text: 'Reading',
        ImagePath: '/assets/images/landing/reading.png',
        DestinationPage: 'Reading',
      },
      {
        Text: 'Listening',
        ImagePath: '/assets/images/landing/practice-audio.png',
        DestinationPage: 'Listening',
      },
      {
        Text: 'Speaking',
        ImagePath: '/assets/images/landing/q-a-audio.png',
        DestinationPage: 'Speaking',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.MoreFromCGP,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'See more CGP revision',
    ButtonURL: '[[external_domain]]/secondary-books/gcse',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'More from CGP',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      "There's plenty more revision where this came from. Take a look at some of our other books!",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Everything you need for revision!',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [],
    HowToRevise: {
      DisplayName: 'GCSE Combined Science',
      BookType: 'Revision Guide',
      AdditionalText: '(you\'ll find some excellent jokes along the way)',
    },
  },
];
